import { theme } from "./theme";

// ── Formátovací helpery (přesunuto z App.js beze změny chování) ────────────────
export const fmt = (n) => n != null ? new Intl.NumberFormat("cs-CZ").format(n) + " Kč" : "—";

export const num = (n) => new Intl.NumberFormat("cs-CZ").format(Math.round(n));

export const timeAgo = (iso) => {
  if (!iso) return "—";
  const diff = Math.floor((new Date() - new Date(iso)) / 60000);
  if (diff < 2) return "právě teď";
  if (diff < 60) return `před ${diff} min`;
  if (diff < 1440) return `před ${Math.floor(diff / 60)} hod`;
  return `před ${Math.floor(diff / 1440)} dny`;
};

export const positionColor = (pos) => {
  if (!pos) return "#9ca3af";
  if (pos === 1) return theme.ok;
  if (pos <= 10) return theme.ink;
  return theme.bad;
};

export const positionBg = (pos) => {
  if (!pos) return "#f3f4f6";
  if (pos === 1) return "#dcfce7";
  if (pos <= 10) return theme.blueSoft;
  return theme.badSoft;
};
